import React, { Component } from 'react'
import Style from '../UserLicenseDetails.module.css'
import { connect } from 'react-redux'
import { formatDetectionDatetime } from '../../utilities/datetime'
import { setCurrentCustomer } from '../../store/entities/customers'
import BackIcon from '../../assets/backButton.svg'
import { getUsersForDevice, getExtensionInstalls, setShowInstallsForUser, getDevices } from '../../store/entities/lmDevicesUsers'
import { isGlobalView } from '../../utilities/config';
import LoaderWrapper from '../common/LoaderWrapper/LoaderWrapper';


class DeviceDetails extends Component {
  state = {
    setCustomerOnce: true,
  }

  showExtensionInstalls = (user) => {
    const isCurrentlyShowing = user.showInstalls;
    this.props.setShowInstallsForUser(user.userId, !isCurrentlyShowing);
    // Only fetch if expanding and installs not already loaded for this user+device
    if (!isCurrentlyShowing) {
      const deviceId = this.props.match.params.deviceId;
      const alreadyLoaded = this.props.extensionInstalls.some(
        ext => String(ext.UserId) === String(user.userId) && String(ext.DeviceId) === String(deviceId)
      );
      if (!alreadyLoaded) {
        let selectedId = this.props.selectedCustomer.id
        let userId = user.userId
        this.props.getExtensionInstalls(selectedId, userId, deviceId)
      }
    }
  }

  fetchDeviceData = () => {
      const deviceId = this.props.match.params.deviceId
      const selectedId = this.props.match.params.customerId
      // const defaultCustomerId = this.props.selectedCustomer?.defaultCustomerId
      // const globalView = isGlobalView(this.props.selectedCustomer?.organizationName)
      this.props.getUsersForDevice(deviceId, selectedId)
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props && this.state.setCustomerOnce && this.props.orgList.length > 0) {
        this.setState({
          setCustomerOnce: false,
        })

        let filtredElement = this.props.orgList.filter((ele) => ele.id === this.props.match.params.customerId)
  
        if (filtredElement[0].id !== this.props.selectedCustomer.id) {
          this.props.setCurrentCustomer(filtredElement[0]);
        }
      }

    if (prevProps.selectedCustomer !== this.props.selectedCustomer && this.props.selectedCustomer) {
      this.fetchDeviceData()
    }
  }

  componentDidMount() {
    if (this.props.selectedCustomer) {
      if(!this.props.selectedDevice){
        this.props.getDevices(null, this.props.match.params.customerId, this.props.selectedCustomer?.defaultCustomerId, isGlobalView(this.props.selectedCustomer?.organizationName), this.props.match.params.deviceId)
      }
      this.fetchDeviceData()
    }
   }

  handleClick = () => {
    !isGlobalView(this.props.selectedCustomer?.organizationName) ?
    this.props.history.push({
      pathname: `/customers/${this.props.match.params.customerId}/license-management`,
      state: { tab: 'Device Info' },
    }):
    this.props.history.push({
      pathname: `/tenants/${this.props.match.params.tenantId}/license-management`,
      state: { tab: 'Device Info' },
    })
  }

  render() {
    const deviceId = this.props.match.params.deviceId
    let { deviceUsers, extensionInstalls } = this.props;
    // let isExpanded = true;
    return (
      <div className={'mt-4'} style={{ paddingLeft: '75px', marginRight: '33px' }}>
        <div className={`${Style.headerBg} d-flex align-items-center justify-content-between`} style={{ paddingLeft: '29px' }}>
          <div onClick={this.handleClick} style={{ cursor: 'pointer' }}>
            <img style={{ height: '19px' }} src={BackIcon} alt={'back-icon'} />
            {' '}Return to Device Info
          </div>
        </div>

        <div className={`mt-4`} style={{ minHeight: '300px' }}>
          <div style={{ paddingLeft: '34px' }}>
            <b>Device: {this.props.selectedDevice?.deviceName}</b>
          </div>
          <div className={`${Style.detailsContainer} mt-2 d-flex scrollX`}>
            <div className={'p-4'} style={{ minWidth: '300px' }}>
              <table className={Style.leftTable}>
                <tbody>
                  <tr>
                    <td className={`py-3 px-2`}><b>Total Users</b></td>
                    <td className={`py-3 px-2`}>{deviceUsers.length}</td>
                  </tr>
                  <tr>
                    <td className={`py-3 px-2`}><b>Active Users</b></td>
                    <td className={`py-3 px-2`} style={{ color: '#85ceae', fontWeight: 'bold' }}>{deviceUsers.filter(user => user.isActive).length}</td>
                  </tr>
                  <tr>
                    <td className={`py-3 px-2`}><b>Inactive Users</b></td>
                    <td className={`py-3 px-2`} style={{ color: '#e57373', fontWeight: 'bold' }}>{deviceUsers.filter(user => !user.isActive).length}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className={Style.divider}></div>
            <div className={`p-4`} style={{ minWidth: '850px' }}>
              <table className={Style.rightTable}>
                <thead>
                  <tr>
                    <td className={`py-3 px-2`} style={{ width: '40%' }}><b>User Name</b></td>
                    <td className={`py-3 px-2`} style={{ width: '25%' }}><b>Status</b></td>
                    <td className={`py-3 px-2`} style={{ width: '35%' }}><b>Last Synced</b></td>
                  </tr>
                </thead>
                <tbody>
                  { this.props.deviceUsersLoading ? (
                    <tr>
                      <td colSpan={3} style={{ textAlign: 'center', padding: '50px 0' }}>
                        <LoaderWrapper loading={this.props.deviceUsersLoading} waitForData={this.props.deviceUsers} isFlex={true} styles={{ minHeight: '380px'}} />
                      </td>
                    </tr>
                  ): (
                  deviceUsers.map((user) => {
                    return (
                      <React.Fragment key={user.userId}>
                        <tr
                          style={{ boxShadow: 'none', background: '#fff', cursor: 'pointer' }}
                          onClick={() => this.showExtensionInstalls(user)}
                        >
                          <td className={`py-3 px-2`}>
                            <span style={{ marginRight: '6px', display: 'inline-block', transform: user.showInstalls ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>&#9654;</span>
                            {user.UserIdentifier}
                          </td>
                          <td className={`py-3 px-2`} style={{ color: user.isActive ? '#85ceae' : '#e57373', fontWeight: 'bold' }}>
                            {user.isActive ? 'Active' : 'Inactive'}
                          </td>
                          <td className={`py-3 px-2`}>{formatDetectionDatetime(user.CreatedOn)}</td>
                        </tr>
                        {user.showInstalls && (() => {
                          const userInstalls = extensionInstalls.filter(
                            ext => String(ext.UserId) === String(user.userId) && String(ext.DeviceId) === String(deviceId)
                          );
                          return this.props.extensionInstallsLoading && userInstalls.length === 0 ? (
                            <tr style={{ boxShadow: 'none', background: '#f9f9f9' }}>
                              <td colSpan={3}><LoaderWrapper loading={true} waitForData={false} isFlex={true} styles={{ minHeight: '40px' }} /></td>
                            </tr>
                          ) : userInstalls.map((ext, idx) => (
                            <tr key={`${user.userId}-${idx}`} style={{ boxShadow: 'none', background: '#f9f9f9' }}>
                              <td className={`py-2 px-2`} style={{ paddingLeft: '32px' }}>{ext.browser} {ext.BrowserVersion}</td>
                              <td className={`py-2 px-2`} style={{ color: ext.isActive ? '#85ceae' : '#e57373', fontWeight: 'bold' }}>
                                {ext.isActive ? 'Active' : 'Inactive'}
                              </td>
                              <td className={`py-2 px-2`}>{formatDetectionDatetime(ext.LastHeartbeat)}</td>
                            </tr>
                          ));
                        })()}
                      </React.Fragment>
                    )
                  }))}
                
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
    selectedCustomer: state.entities.customers.selected,
    orgList: state.entities.customers.list,
    deviceUsers: state.entities.lmDevicesUsers.deviceUsers,
    deviceUsersLoading: state.entities.lmDevicesUsers.deviceUsersLoading,
    selectedDevice: state.entities.lmDevicesUsers.selectedDevice,
    extensionInstalls: state.entities.lmDevicesUsers.extensionInstalls,
    extensionInstallsLoading: state.entities.lmDevicesUsers.extensionInstallsLoading,
    devicesList: state.entities.lmDevicesUsers.devices,
})

const mapDispatchToProps = (dispatch) => ({
    setCurrentCustomer: (customerId) => dispatch(setCurrentCustomer(customerId)),
    getDevices: (filters, selectedId, defaultCustomerId, isGlobalView, deviceId = null) => dispatch(getDevices(filters, selectedId, defaultCustomerId, isGlobalView, deviceId)),
    getUsersForDevice: (deviceId, customerId, defaultCustomerId, isGlobal) => dispatch(getUsersForDevice(deviceId, customerId)),
    getExtensionInstalls: (selectedCustomerId, userId, deviceId) => dispatch(getExtensionInstalls(selectedCustomerId, userId, deviceId)),
    setShowInstallsForUser: (userId, showInstalls) => dispatch(setShowInstallsForUser(userId, showInstalls)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DeviceDetails)
